import { Injectable, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatStepper } from '@angular/material/stepper';
import { BehaviorSubject, skip, takeWhile, timer } from 'rxjs';
import { OpenMoldComponent } from '../../../feature/new-foaming/components/open-mold/open-mold/open-mold.component';
import { Foam, FoamingObj, Part, Simulate, Gravity, Meshing, Recipe } from '@usimweb/core/models';

import { Helper, VtkJsReader } from '@usimweb/core/services';
import { ApiService } from '@usimweb/core/services';

@Injectable({
  providedIn: 'root',
})
export class GeometryService {
  private project_uuid: string = '';
  private foaming: FoamingObj = {
    project: '',
    title: '',
    owner: '',
    materialName: '',
    gravityX: 0,
    gravityY: 0,
    gravityZ: 0,
    simulationTime: 0,
    outputTime: 0,
    materialTemperature: 0,
    recipe: 0,
    mesh: '',
    injectionRate: 0,
    targetDensity: 0,
    nCpus: 0,
  };

  public simulate: Simulate = {
    name: '',
    cpus: 0,
    simulationTime: 60,
    outPutTime: 1,
    appType: '',
    credits: 0,
  };
  public part: Part = {
    cadModel: '',
    modelKey: '',
    gravityX: 0,
    gravityZ: 0,
    gravityY: 0,
    volume: 0,
    partId: '',
    name: '',
    credits: 0,
  };

  public title: string | undefined;
  public meshes: Meshing[] = [];
  public foams: Foam[] = [];
  public recipes: Recipe[] = [];
  public temperatures: number[] = [];
  public cpus: {} = {};
  public defaultCpu = 0;
  public credits = 0;
  public selectedMesh: string = '';

  public freeRiseDensity: number | undefined;
  public initialDensity: number | undefined;
  public volume: number = 0;
  public injectionTime: number = 0;
  public gravity: Gravity = { x: 0, y: 0, z: 0 };

  public viewer = 0;

  public isOpenMold = false;
  public isBoundaryPart = false;
  public loadViewerTwo = false;
  public loadViewerThree = false;
  public cadModelChanged = false;
  public isOpenMoldVisible = false;
  public vtkpreview = false;

  public isTaskAlive: boolean = false;
  public isPrevLoading: boolean = false;

  public boundingBoxParts = [];

  @ViewChild('stepper') matStepper!: MatStepper;
  @ViewChild(OpenMoldComponent) openMoldComponent!: OpenMoldComponent;

  constructor(private apiService: ApiService, private snackBar: MatSnackBar) {}

  public isPrevLoadingCallBack = new BehaviorSubject<boolean>(false);

  public initViewChilds(openMoldComponent: OpenMoldComponent) {
    this.openMoldComponent = openMoldComponent;
  }

  public getPreview(uuid: string, vtkpreview: boolean) {
    const subscription = this.apiService.getGeometriePreview(uuid, 'vtkjs').subscribe((response) => {
      subscription.unsubscribe();

      vtkpreview = false;

      let divElement = document.getElementById('vtkjsPreviewDiv');
      if (divElement) {
        vtkpreview = VtkJsReader.loadfile(divElement, response);
      }

      let calledPreview = false;

      VtkJsReader.isRendering.pipe(skip(1)).subscribe((isRendering: boolean) => {
        this.isPrevLoadingCallBack.next(isRendering);

        this.openMoldComponent.previewLoadModel(uuid);
        calledPreview = true;
      });
    });
  }

  public openModel(event: { id: string }, vtkpreview: boolean, openMoldComponent: OpenMoldComponent): void {
    this.isPrevLoading = true;
    const uuid = event['id'];
    this.getPreview(uuid, vtkpreview);

    this.foaming.mesh = uuid;

    const subscriptionMesh = this.apiService.getGeometryById(uuid).subscribe((mesh: Meshing) => {
      subscriptionMesh.unsubscribe();

      this.gravity.x = mesh.gravityX || 0;
      this.gravity.y = mesh.gravityY || 0;
      this.gravity.z = mesh.gravityZ || 0;

      this.part = {
        modelKey: mesh.id,
        cadModel: mesh.title,
        gravityX: mesh.gravityX,
        gravityZ: mesh.gravityZ,
        gravityY: mesh.gravityY,
        volume: mesh.volume,
        credits: mesh.credits,
      } as Part;
      this.simulate.appType = mesh.appType;

      this.credits = (this.part.credits || 0) + 100 + this.simulate.simulationTime * 1.2;
      this.simulate.credits = this.credits;

      this.cpus = mesh.ncpus || this.cpus;
      this.defaultCpu = parseFloat(Helper.Array.findValueByKey(mesh.ncpus, 'default') || '0');
      this.volume = mesh.volume || 0;

      this.isOpenMold = mesh.appType.endsWith('-open') || mesh.appType.endsWith('_open') ? true : false;

      this.cadModelChanged = true;
    });
  }

  public getGeometry(event: any) {
    this.isTaskAlive = true;
    this.snackBar.open('Started meshing....', 'OK', { duration: 2000 });

    this.matStepper.selectedIndex = 1;

    this.meshes.push({
      id: event.id,
      title: event.title + ' (In process)',
      stlFile: event.file,
      appType: event.appType,
      modelKey: '',
    });
    this.selectedMesh = event.id;

    timer(0, 3000)
      .pipe(takeWhile(() => this.isTaskAlive))
      .subscribe(() => {
        const subscriptionMesh = this.apiService.getGeometryById(event.id).subscribe((response) => {
          subscriptionMesh.unsubscribe();

          const progress = response['progress'];
          if (progress == 100) {
            this.isTaskAlive = false;

            const subscriptionMeshes = this.apiService
              .getGeometries(this.project_uuid)
              .subscribe((meshing: Meshing[]) => {
                subscriptionMeshes.unsubscribe();

                for (let i = 0; i < meshing.length; i++) {
                  if (meshing[i].uuid === event.id) {
                    this.meshes = meshing;
                    this.selectedMesh = event.id;
                  }
                }

                //this.openModel(event,  vtkpreview, openMoldComponent: OpenMoldComponent);
                this.snackBar.open('Finished meshing....', 'OK', {
                  duration: 2000,
                });
              });
          }
        });
      });
  }
}
